var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"headerTitle":"Публичная оферта","hideFooter":"","hideReload":""}},[_c('template',{slot:"block"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.offerHTML)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }